import React from "react";
import ChallengeProgressBar from "./ChallengeProgressBar";
import moment from "moment";

const SummarySection = ({ details, currentUserId }) => {
  const getGoal = () => {
    if (details.goal !== null) {
      if (details.goal_type === "Cumulative") {
        return `${details.goal} ${details.positive ? "Total" : ""} ${
          details.unit
        } ${details.positive ? "" : "or less"}`;
      } else if (details.goal_type === "Improvement") {
        return `${details.goal}% ${
          details.positive ? "Increase" : "Decrease"
        } in ${details.unit}`;
      } else {
        return `${details.goal} Avg ${details.unit}`;
      }
    } else {
      return `${details.positive ? "Highest" : "Lowest"} ${
        details.goal_type === "Cumulative"
          ? "Total"
          : details.goal_type === "Improvement"
          ? "Change in"
          : "Avg"
      } ${details.unit}`;
    }
  };

  const detail_item = [
    {
      item: "Challenge Ends:",
      value: details.end_on_goal
        ? "At Goal"
        : moment(details.end_date, "MM/DD/YYYY").format("M/D/YYYY")
    },
    {
      item: "Challenge Type:",
      value: details.type
    },
    {
      item: "Goal:",
      value: getGoal()
    },
    {
      item: "My Progress:",
      value:
        details.participants.find((user) => user.user_id === currentUserId)
          .data +
        (details.goal_type === "Cumulative"
          ? ` Total`
          : details.goal_type === "Average"
          ? ` Avg`
          : details.positive
          ? "% Increase"
          : "% Decrease")
    },
    {
      item: "Leader:",
      type: "Competitive",
      value:
        (details.goal_type !== "Improvement"
          ? details.positive
            ? details.participants.reduce(
                (max, user) => Math.max(max, user.data),
                details.participants[0].data
              )
            : details.participants.reduce(
                (min, user) => Math.min(min, user.data),
                details.participants[0].data
              )
          : details.participants.reduce(
              (max, user) => Math.max(max, user.data),
              details.participants[0].data
            )) +
        (details.goal_type === "Cumulative"
          ? ` Total`
          : details.goal_type === "Average"
          ? ` Avg`
          : details.positive
          ? "% Increase"
          : "% Decrease")
    }
  ];

  const getTimePercentage = () => {
    const duration = moment(details.end_date, "MM/DD/YYYY").diff(
      moment(details.start_date, "MM/DD/YYYY"),
      "days"
    );
    const time_elapsed = moment().diff(
      moment(details.start_date, "MM/DD/YYYY"),
      "days"
    );
    return Math.round((time_elapsed / duration) * 100);
  };

  const getGoalPercentage = () => {
    if (details.goal !== null) {
      if (details.type === "Cooperative") {
        return Math.round((details.current_data / details.goal) * 100);
      } else {
        const player_data = details.participants.find(
          (user) => user.user_id === currentUserId
        ).data;
        return Math.round((player_data / details.goal) * 100);
      }
    }
  };

  const getBarInfo = () => {
    const endDate = moment(details.end_date, "MM/DD/YYYY").format("M/D/YYYY");
    const userData = details.participants.find(
      (item) => item.user_id === currentUserId
    ).data;

    if (details.goal !== null) {
      if (details.goal_type === "Cumulative") {
        if (details.positive) {
          return `${
            details.type === "Cooperative" ? details.current_data : userData
          }/${details.goal} ${details.unit}`;
        } else {
          return `${userData}/${details.goal} ${details.unit}`;
        }
      } else {
        return `${details.goal}${
          details.goal_type === "Average"
            ? " Avg"
            : details.positive
            ? "% Increase"
            : "% Decrease"
        } by ${endDate}`;
      }
    } else {
      return `${details.positive ? "Highest" : "Lowest"} ${
        details.goal_type === "Cumulative"
          ? "Total"
          : details.goal_type === "Improvement"
          ? "Change"
          : "Avg"
      } by ${endDate}`;
    }
  };

  return (
    <div className="summary-section">
      <h2 className="summary-heading"> 🔍 Challenge Summary</h2>
      <div className="summary-details">
        {detail_item.map(
          (data, index) =>
            (data.type === undefined || data.type === details.type) && (
              <div key={index} className="detail">
                <span className="detail-text">{data.item}</span>
                <span className="detail-text">{data.value}</span>
              </div>
            )
        )}
      </div>
      <div className="detail challenge-progress">
        <span className="detail-text">
          {details.goal === null
            ? "Challenge Time Left:"
            : "Challenge Progress:"}
        </span>
        <ChallengeProgressBar
          details={details}
          getTimeWidth={getTimePercentage}
          getGoalWidth={getGoalPercentage}
        />
        <span className="bar-data">{getBarInfo()}</span>
      </div>
    </div>
  );
};

export default SummarySection;
